import { globalStyle, style } from '@vanilla-extract/css';
import { nToPx, shine, themeVars, toBorder } from '@tundr/theme';

export const phoneInputWrapperClass = style({
  borderRadius: themeVars.radius.sm,
  outline: 'none',
  boxShadow: 'none !important', // fix focus shadow
  border: 'none !important',
  fontSize: themeVars.font.size.textLg,

  selectors: {
    '&:focus:not(.disabled)': {
      outline: `2px solid ${themeVars.colors.brand.secondary.x100}`,
    },
  },
});

export const phoneInputClass = style({
  borderRadius: themeVars.radius.md,
  outline: 'none',
  height: 48,
  paddingTop: 1,
  backgroundColor: themeVars.colors.neutrals.white,
  position: 'relative',
  paddingRight: themeVars.space.x4,
  paddingLeft: themeVars.space.x3,
  border: toBorder(themeVars.colors.neutrals.grey50),

  selectors: {
    '&::placeholder': {
      color: themeVars.colors.neutrals.grey60,
    },
  },
});

export const phoneInputLoaderClass = style([
  shine,
  {
    pointerEvents: 'none',
    backgroundSize: '200% 100%',
    backgroundImage: `linear-gradient(90deg, ${themeVars.colors.neutrals.grey40} 0px, ${themeVars.colors.neutrals.grey30} 30%, ${themeVars.colors.neutrals.white} 50%,${themeVars.colors.neutrals.grey40} 100%)`,
    opacity: 0.7,
    outline: 'none',
  },
]);

globalStyle(`.vti__dropdown`, {
  padding: nToPx(0, themeVars.space.x2),
  marginRight: themeVars.space.x1,
  border: toBorder(themeVars.colors.neutrals.grey50),
  borderRadius: themeVars.radius.md,
  backgroundColor: themeVars.colors.neutrals.white,
});

globalStyle(`.vti__country-code`, {
  paddingRight: themeVars.space.x1,
});

globalStyle(`.vti__dropdown:hover`, {
  backgroundColor: 'inherit',
});

globalStyle(`.vue-tel-input:focus-within`, {
  outline: 'none',
  borderColor: themeVars.colors.neutrals.grey70,
});

globalStyle(`.vue-tel-input.disabled input`, {
  backgroundColor: themeVars.colors.neutrals.grey30,
  cursor: 'not-allowed',
});

globalStyle('.vti__dropdown-list', {
  marginTop: themeVars.space.x1,
  borderRadius: themeVars.radius.md,
  overflowX: 'hidden',
  padding: 0,
  fontSize: themeVars.font.size.textSm,
  width: 'auto',
  minWidth: 300,
});

globalStyle('.vti__search_box', {
  borderRadius: themeVars.radius.md,
  margin: themeVars.space.x2,
  border: toBorder(themeVars.colors.neutrals.grey70),
});

globalStyle('.vti__dropdown-item', {
  padding: themeVars.space.x2,
});
